(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ReserveCountByParentIdController', ReserveCountByParentIdController);

    ReserveCountByParentIdController.$inject = ['$scope', 'ExportService', '$uibModalInstance', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ServiceItemCustom', 'ServiceCategoryCustom', 'ReportService', 'CompanyCustom', '$translate', 'DateUtils'];

    function ReserveCountByParentIdController($scope, ExportService, $uibModalInstance, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, ServiceItemCustom, ServiceCategoryCustom, ReportService, CompanyCustom, translate, DateUtils) {
        var vm = this;
        vm.serviceItemId = "";
        vm.serviceItems = [];
        vm.orderBagStatus;
        vm.fromDateFilter = new Date();
        vm.toDateFilter = new Date();
        vm.downloadlink = '#';
        vm.currentCompany = null;
        vm.selectedCompanyId = null;


        vm.cancel = cancel;
        vm.confirm = confirm;
        vm.errorOnCreatingReport = false;
        vm.reportCreatedAndDownload = false;
        vm.errorOnCreatingReport = false;
        vm.spname = '';
        vm.parameters = [];
        vm.doBeforeExport = doBeforeExport;
        loadAll();


        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
                vm.currentCompany = result;
                if (vm.currentCompany)
                    vm.childCompanies = CompanyCustom.getCompaniesByParentId(vm.currentCompany.id).query(function (data) {
                        vm.childCompanies = data;
                    });

            });
        }

        function getCompaniesByParentId() {

        }

        function loadAll() {
            findCurrentCompany();

        }

        function confirm() {

            vm.errorOnCreatingReport = true;
            vm.reportCreatedAndDownload = false;
            vm.errorOnCreatingReport = false;
            var file = ExportService.export_excel_orderbag_list_by_service(vm.serviceItemId, vm.fromDateFilter, vm.toDateFilter, vm.orderBagStatus);
            ExportService.download_excel_file(file, onExportSuccess, onExportErrorr);

        }

        function onExportErrorr(error) {
            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = false;
            vm.errorOnCreatingReport = true;
        }

        function onExportSuccess(result) {
            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = true;
            vm.errorOnCreatingReport = false;
            vm.downloadlink = result.dllink;
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function doBeforeExport() {

            var report_config = {
                spname: 'sp_province_branch_service_date_count',
                parameters: [{
                    name: 'f_province_id',
                    value: (vm.currentCompany.id) ? vm.currentCompany.id : 'null',
                    type: 'long'
                },
                    {name: 'f_branch_id', value: (vm.selectedCompanyId) ? vm.selectedCompanyId : 'null', type: 'long'},
                    {name: 'f_service_id', value: 'null', type: 'long'},
                    {name: 'f_from_date', value: DateUtils.convertToISOString(vm.fromDateFilter), type: 'date'},
                    {name: 'f_to_date', value: DateUtils.convertToISOString(vm.toDateFilter), type: 'date'}
                ]
            };
            return report_config;


        }
    }
})();
